/**
 * StatsCards - Dashboard stat cards with live counts.
 * Clicking a card navigates to the invoices list with the appropriate filter.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardCounts } from '../../../services/documentApi';

interface StatsCardsProps {
    counts: DashboardCounts | null;
    loading: boolean;
}

const CARDS = [
    { key: 'total' as const, label: 'Total Invoices', color: '#3b82f6', filter: '' },
    { key: 'matched' as const, label: 'Matched', color: '#10b981', filter: 'matched' },
    { key: 'discrepancy' as const, label: 'Discrepancies', color: '#f59e0b', filter: 'discrepancy' },
    { key: 'pending' as const, label: 'Pending Review', color: '#6b7280', filter: 'unmatched' },
];

const StatsCards: React.FC<StatsCardsProps> = ({ counts, loading }) => {
    const navigate = useNavigate();

    const handleClick = (filter: string) => {
        const path = filter ? `/reconciliation?filter=${filter}` : '/reconciliation';
        navigate(path);
    };

    return (
        <div className="dashboard__stats">
            {CARDS.map((card) => (
                <div
                    key={card.key}
                    className="dashboard__stat-card dashboard__stat-card--clickable"
                    onClick={() => handleClick(card.filter)}
                >
                    <div className="dashboard__stat-value" style={{ color: card.color }}>
                        {loading ? '...' : (counts?.[card.key] ?? 0)}
                    </div>
                    <div className="dashboard__stat-label">{card.label}</div>
                </div>
            ))}
        </div>
    );
};

export default StatsCards;
